// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__SG9pE","floating":"header_floating__uujdo","shadow":"header_shadow__cjQIv"};